// chatbot-core.js — guarded against double init + greet-once-per-session

(function () {
  if (window.__AQ_CHATBOT_CORE_INIT__) return;
  window.__AQ_CHATBOT_CORE_INIT__ = true;

  function bindOnce(el, evt, handler, opts) {
    if (!el) return;
    const key = `__bound_${evt}`;
    if (el[key]) return;
    el.addEventListener(evt, handler, opts);
    el[key] = true;
  }

  document.addEventListener("DOMContentLoaded", init, { once: true });

  function init() {
    const chatToggle      = document.getElementById("chat-toggle");
    const chatbot         = document.getElementById("chatbot");
    const chatToggleIcon  = document.getElementById("chat-toggle-icon");
    const chatWindow      = document.getElementById("chat-window");
    const userInputEl     = document.getElementById("user-input");
    const endChatButton   = document.getElementById("end-chat-button");
    const sendBtn         = document.getElementById("send-button");

    let chatOpen = false;
    let chatHistory = [];

    if (localStorage.getItem("chatHistory")) {
      try { chatHistory = JSON.parse(localStorage.getItem("chatHistory")) || []; }
      catch (e) { chatHistory = []; }
    }

    function updateChatHistory() {
      localStorage.setItem("chatHistory", JSON.stringify(chatHistory));
    }

    function appendMessage(role, content, save = true) {
      const text = (content ?? "").trim();
      if (!text) return;
      const p = document.createElement("p");
      p.className = role === "user" ? "user-message fade-in" : "bot-message fade-in";
      p.innerHTML = text;
      if (role === "user") p.style.marginLeft = "auto";
      else p.style.marginRight = "auto";
      chatWindow.appendChild(p);
      if (save) {
        chatHistory.push({ role, content: text });
        updateChatHistory();
      }
      chatWindow.scrollTop = chatWindow.scrollHeight;
    }

    function renderChatHistory() {
      chatWindow.innerHTML = "";
      if (chatHistory.length === 0) {
        if (!sessionStorage.getItem("aq_greeted")) {
          chatWindow.innerHTML = `<p class="bot-message fade-in"><em>Welcome! How can we help you today?</em></p>`;
          sessionStorage.setItem("aq_greeted", "1");
        }
      } else {
        chatHistory.forEach(m => appendMessage(m.role, m.content, false));
      }
    }

    bindOnce(chatToggle, "click", function (event) {
      if (chatOpen) {
  chatbot.classList.remove("open");
  setTimeout(() => {
    chatbot.style.display = "none";
    document.body.style.overflow = "auto";
    // Reset chat when closed
    chatHistory = [];
    localStorage.removeItem("chatHistory");
    sessionStorage.removeItem("aq_greeted");
    if (chatWindow) {
      chatWindow.innerHTML = `<p class="bot-message fade-in"><em>Welcome! How can we help you today?</em></p>`;
    }
  }, 300);

        if (chatToggleIcon) {
          chatToggleIcon.innerHTML = `<path d="M20 2H4a2 2 0 0 0-2 2v14l4-4h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z"/>`;
        }
        chatOpen = false;
      } else {
        chatbot.style.display = "flex";
        setTimeout(() => { chatbot.classList.add("open"); }, 10);
        if (userInputEl) userInputEl.focus();
        renderChatHistory();
        if (chatToggleIcon) {
          chatToggleIcon.innerHTML = `<line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>`;
        }
        chatOpen = true;
      }
      if (event) event.stopPropagation();
    });

    bindOnce(document, "click", function (event) {
      if (!chatOpen) return;
      if (!chatbot.contains(event.target) && event.target !== chatToggle) {
        chatbot.classList.remove("open");
        setTimeout(() => { chatbot.style.display = "none"; }, 300);
        if (chatToggleIcon) {
          chatToggleIcon.innerHTML = `<path d="M20 2H4a2 2 0 0 0-2 2v14l4-4h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z"/>`;
        }
        chatOpen = false;
      }
    });

    function showContactMessage() {
      const closingPrompt = document.querySelector(".closing-message");
      if (closingPrompt) closingPrompt.remove();

      const contactInfo = `<em>
        Please email us at
        <a href="mailto:info@aquaquestwaterproof.com" class="support-link">info@aquaquestwaterproof.com</a>
        or call
        Toll Free:
        <a href="tel:+18447757770" class="support-link">1-844-775-7770</a>
        (USA/Canada)
        or International:
        <a href="tel:+12508718011" class="support-link">+1-250-871-8011</a>
        so we can help further.
      </em>`;
      appendMessage("bot", contactInfo);

      setTimeout(() => {
        if (chatbot && chatbot.classList) {
          chatbot.classList.add("open");
          chatWindow.scrollTop = chatWindow.scrollHeight;
        }
      }, 100);
    }

    if (endChatButton) {
      endChatButton.textContent = "Contact Our Team";
      endChatButton.setAttribute("aria-label", "Contact Our Team");
      endChatButton.style.display = "inline-block";
      bindOnce(endChatButton, "click", function (event) {
        event.preventDefault();
        showContactMessage();
      });
    }

    if (userInputEl) {
      bindOnce(userInputEl, "input", function () {
        this.style.height = "auto";
        const minHeight = 60, maxHeight = 80;
        let newHeight = Math.max(this.scrollHeight, minHeight);
        if (newHeight > maxHeight) {
          newHeight = maxHeight; this.style.overflowY = "auto";
        } else this.style.overflowY = "hidden";
        this.style.height = newHeight + "px";
      });
      bindOnce(userInputEl, "keypress", function (event) {
        if (event.key === "Enter" && !event.shiftKey) {
          event.preventDefault();
          sendMessage();
        }
      });
    }

    if (sendBtn) bindOnce(sendBtn, "click", sendMessage);

    async function sendMessage() {
      const userInput = (userInputEl?.value || "").trim();
      if (!userInput) return;

      appendMessage("user", userInput);

      if (window.logInteraction) {
        try { await window.logInteraction("user", userInput); }
        catch (e) { console.error("logInteraction user failed:", e); }
      }

      if (userInputEl) {
        userInputEl.value = "";
        userInputEl.style.height = "60px";
        userInputEl.style.overflowY = "hidden";
      }

      const thinkingElem = document.createElement("div");
      thinkingElem.className = "thinking-indicator fade-in";
      thinkingElem.innerHTML = `<div class="three-dots">
                                  <span class="dot"></span>
                                  <span class="dot"></span>
                                  <span class="dot"></span>
                                </div>`;
      chatWindow.appendChild(thinkingElem);
      chatWindow.scrollTop = chatWindow.scrollHeight;

      try {
        const response = await fetch('https://chatassistanthttp-abk3iaaida-uc.a.run.app', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ message: userInput })
        });
        const responseText = await response.text();
        let result;
        try { result = JSON.parse(responseText); }
        catch (e) { throw new Error(`Failed to parse JSON: ${responseText}`); }

        thinkingElem.remove();
        const botResponse = (result && result.message)
          ? String(result.message)
          : "Sorry, I didn't catch that.";
        appendMessage("bot", botResponse);

        if (window.logInteraction && botResponse.trim()) {
          try { await window.logInteraction("bot", botResponse); }
          catch (e) { console.error("logInteraction bot failed:", e); }
        }
      } catch (error) {
        console.error("Reply error:", error);
        thinkingElem.remove();
        appendMessage("bot", "Sorry, something went wrong. Please try again later.");
      }

      chatWindow.scrollTop = chatWindow.scrollHeight;
    }

    bindOnce(chatToggle, 'touchend', function(e) { e.preventDefault(); this.click(); });
    bindOnce(chatbot, 'touchmove', function(e) { e.stopPropagation(); });
  }
})();
